import styled from 'styled-components';

export const TextFieldStyled = styled.div`
  position: relative;

  > div {
    // atlassian TextField Container
    > input {
      // atlassian TextField Input
      ${({ hasSuffix }) => hasSuffix && 'padding-right: 40px'}
    }
  }
`;

export const TextFieldIconStyled = styled.div`
  // disable click on element
  pointer-events: none;
  position: absolute;
  top: 0;
  // to the right
  right: 0;
  bottom: 0;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
